import {createUseStyles} from 'react-jss';
import Typography from '../../../style-helper/Typography';
import loadArtemisFonts from '../../ui/loadArtemisFonts';

export default createUseStyles({
  progressStep: {
    width: '33%',
    textAlign: 'center',
    textDecoration: 'none',
    padding: 0,
  },
  
  label: props => ({
    fontSize: props.theme.progressBar.fontSize,
    fontWeight: props.theme.progressBar.labelFontWeight || props.theme.core.boldFontWeight,
    lineHeight: 1.2,
    padding: [0, 8],
    color: props.theme.progressBar.staticLabelColour
      ? (props.theme.progressBar.labelColour || props.theme.progressBar.colour) : '#b3b3b3',
    textTransform: props.theme.progressBar.isUppercase && 'uppercase',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    wordBreak: 'break-word',
    
    ...(props.isUsingArtemisStyles && props.theme.typography?.[props.theme.progressBar.labelFont])
    && loadArtemisFonts(props.theme.typography[props.theme.progressBar.labelFont], props.theme.progressBar.isBold),
  
    ...(props.active || props.complete) && ({
      transition: 'color 0.2s linear 0.7s',
      color: props.theme.progressBar.labelColour || props.theme.progressBar.colour,
    }),
  }),
});
